import { AppName } from 'root-constants'
import { TAppName } from 'root-types'

type TAppConfigWithDomains = Record<TAppName, { domains: readonly string[] }>

export const detectAppName = (
  configMap: TAppConfigWithDomains,
  defaultApp: TAppName = AppName.ayahPath,
): TAppName => {
  const hostname = window.location.hostname.toLowerCase()

  const detectedAppName = Object.values(AppName).find((name) =>
    configMap[name].domains.some((domain) => hostname.includes(domain)),
  )

  return detectedAppName ?? defaultApp
}
